import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import BasetaoReview2026 from "../pages/article/basetao-review-2026/page";
import IsBasetaoLegit from "../pages/article/is-basetao-legit/page";
import BasetaoShippingCost from "../pages/article/basetao-shipping-cost/page";
import BasetaoWarehouseGuide from "../pages/article/basetao-warehouse-guide/page";
import BasetaoCouponDiscount from "../pages/article/basetao-coupon-discount/page";
import BasetaoProductFinds from "../pages/article/basetao-product-finds/page";
import BasetaoVsCompetitors from "../pages/article/basetao-vs-competitors/page";
import BasetaoBeginnerGuide from "../pages/article/basetao-beginner-guide/page";
import BasetaoSafetyTips from "../pages/article/basetao-safety-tips/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-ultimate-guide",
    element: <ArticlePage />,
  },
  {
    path: "/basetao-review-2026",
    element: <BasetaoReview2026 />,
  },
  {
    path: "/is-basetao-legit",
    element: <IsBasetaoLegit />,
  },
  {
    path: "/basetao-shipping-cost",
    element: <BasetaoShippingCost />,
  },
  {
    path: "/basetao-warehouse-guide",
    element: <BasetaoWarehouseGuide />,
  },
  {
    path: "/basetao-coupon-discount",
    element: <BasetaoCouponDiscount />,
  },
  {
    path: "/basetao-product-finds",
    element: <BasetaoProductFinds />,
  },
  {
    path: "/basetao-vs-competitors",
    element: <BasetaoVsCompetitors />,
  },
  {
    path: "/basetao-beginner-guide",
    element: <BasetaoBeginnerGuide />,
  },
  {
    path: "/basetao-safety-tips",
    element: <BasetaoSafetyTips />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;